import { Component, OnInit, OnDestroy } from '@angular/core';
import { Report, ReportOverview, ReportService } from '../shared';

@Component({
  selector: 'bp-report-list',
  templateUrl: 'report-list.component.html'
})

export class ReportListComponent implements OnInit, OnDestroy {


  reports: ReportOverview[];

  constructor(
    private reportService: ReportService
  ) { }

  ngOnInit() {
    this.getReports();

  }

  ngOnDestroy(): void {

  }
  getReports() {
    

    this.reportService.getReports()
      .subscribe(reports => {
        this.reports = [];
        this.reports = reports;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/reports/report-list/report-list.component.ts